import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { getAPIURL } from '../config/api'

// 创建axios实例
const apiClient: AxiosInstance = axios.create({
  baseURL: getAPIURL(),
  timeout: 30000, // 增加超时时间到30秒
})

// No runtime prefix detection — use canonical `getAPIURL()` (now points to /api).

// 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 如果是 FormData（文件上传），删除 Content-Type 让 axios 自动设置 multipart/form-data
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 检查是否是获取用户信息的请求，如果是则不自动登出
      const isProfileRequest = error.config?.url?.includes('/auth/profile')
      // 检查是否是 settings 页面相关请求（打开设置页面时我们不希望直接强制登出）
      const isSettingsRequest = error.config?.url?.includes('/settings')
      // 检查是否在登录页面，如果是则不自动登出
      const isLoginPage = window.location.pathname.includes('/auth/login')
      // 检查是否是登录/注册相关的请求，如果是则不自动登出
      const isAuthRequest = error.config?.url?.includes('/auth/login') || error.config?.url?.includes('/auth/register')

      if (!isProfileRequest && !isLoginPage && !isAuthRequest && !isSettingsRequest) {
        // 未授权，清除token并跳转到登录页
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        // 避免在登录页面重复跳转
        if (!window.location.pathname.includes('/auth/login')) {
          window.location.href = '/auth/login'
        }
      }
    }
    return Promise.reject(error)
  },
)

// API服务类
class ApiService {
  // 通用请求方法
  public async request<T = any>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return apiClient.request<T>(config)
  }

  // GET请求
  public async get<T = any>(url: string, params?: any): Promise<AxiosResponse<T>> {
    return apiClient.get<T>(url, { params })
  }

  // POST请求
  public async post<T = any>(url: string, data?: any): Promise<AxiosResponse<T>> {
    return apiClient.post<T>(url, data)
  }

  // PUT请求
  public async put<T = any>(url: string, data?: any): Promise<AxiosResponse<T>> {
    return apiClient.put<T>(url, data)
  }

  // PATCH请求
  public async patch<T = any>(url: string, data?: any): Promise<AxiosResponse<T>> {
    return apiClient.patch<T>(url, data)
  }

  // DELETE请求
  public async delete<T = any>(url: string): Promise<AxiosResponse<T>> {
    return apiClient.delete<T>(url)
  }
}

export { apiClient }
export default new ApiService()
